import { SharePeople } from '@brandfolder/icons';
import React, { FunctionComponent } from 'react';

export const PeopleIcon: FunctionComponent = () => {
  return (
    <SharePeople />
  );
};

export default PeopleIcon;
